import React, { useMemo } from "react";
import { LocaleContext, getTranslations, type Locale, DEFAULT_LOCALE } from "./index";
import { I18nProvider } from "react-aria";

type LocaleProviderProps = {
  locale?: Locale;
  children: React.ReactNode;
};

export function LocaleProvider({ locale = DEFAULT_LOCALE, children }: LocaleProviderProps) {
  const value = useMemo(
    () => ({ locale, t: getTranslations(locale) }),
    [locale],
  );

  return (
    <LocaleContext.Provider value={value}>
      <I18nProvider locale={locale}>
        {children}
      </I18nProvider>
    </LocaleContext.Provider>
  );
}
